<template>
  <div class="percentage-chart">
    <div class="item" v-for="item in data" :key="item.title">
      <div class="title">{{ item.title }}</div>
      <div class="value">
        <span>{{ item.value }}%</span>
        <div class="progress-bar">
          <div
            class="progress-bar-inner"
            :style="{ width: item.value + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
// 这里可以引入 props 或后续逻辑
const data = [
  {
    type: "device",
    title: "设备故障率",
    value: 2.3,
  },
  {
    type: "device",
    title: "维护周期达标率",
    value: 99.99,
  },
  {
    type: "device",
    title: "设备完好率",
    value: 99.99,
  },
  {
    type: "device",
    title: "设备开机率",
    value: 99.99,
  },
  {
    type: "device",
    title: "设备协议符合率",
    value: 99.99,
  },
];
</script>
<style scoped lang="less">
@import "@/assets/css/global.less";
.percentage-chart {
  width: 100%;
  background-color: @card-background-color;
  border-radius: 8px;
  padding: 10px;
  .item {
    display: flex;
    flex-direction: row;
    gap: 10px;
    line-height: @bar-chart-box-height;
    .title {
      font-size: 14px;
      color: @text-color-secondary;
      flex: 0 0 140px;
      text-align: right;
    }
    .value {
      flex: 1;
      text-align: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;
      span {
        position: absolute;
        left: 10px;
        top: 0;
        font-size: 18px;
        color: @text-color;
      }
      .progress-bar {
        width: 100%;
        height: @bar-chart-height;
        .progress-bar-inner {
          height: 100%;
          background-color: @card-border-color;
          border-radius: 10px;
          transition: width 0.3s;
          display: block;
        }
      }
    }
  }
}
</style>
